<template>
  <div
    class="
      product_single_content_box product_single_box product_single_right_box
      secondary_title
    "
    style="position: relative"
    :class="{
      showtime_add: theme == 'showtime',
      vogue_add: theme == 'vogue',
      athena_add: theme == 'athena',
    }"
  >
    <v-countdown
      v-if="count_down && count_down_show"
      :count_down="count_down"
      position="detail"
      theme="venue"
    ></v-countdown>
    <div class="product_single_price">
      <h1
        v-if="theme == 'showtime' || theme == 'vogue' || theme == 'athena'"
        class="title_font2"
      >
        {{ product_res.post_title }}
      </h1>
      <h5
        v-if="theme == 'athena' && product_res.subtitle"
        class="product_subtitle"
      >
        {{ product_res.subtitle }}
      </h5>
      <v-proDelStart
        v-if="comment && ((theme=='vogue' && show_comment_score) || theme!='vogue')"
        :average_rating="product_res.average_rating"
        :review_count="product_res.review_count"
        :intro_style="theme == 'athena'"
        :theme="theme"
      ></v-proDelStart>
      <p
        class="page_text_font"
        v-if="singlecommodity == 'singlecommodity'"
        v-html="singlecommoditydescription"
        style="background: none"
      ></p>
      <h3 class="product_single_price_text">
        <v-selectprice
          :currency_style="currency_style"
          :price="(computed_price && computed_price.price) || now_variant.price"
          :regular_price_num="
            (computed_price &&
              computed_price.regular_price > computed_price.price &&
              computed_price.regular_price) ||
            (now_variant.price - 0 < now_variant.regular_price - 0
              ? now_variant.regular_price
              : 0)
          "
          :disable_select="
            theme == 'showtime' || theme == 'vogue' || theme == 'athena'
              ? 'true'
              : !show_currency_selector
          "
          :country="
            theme == 'showtime' || theme == 'vogue' || theme == 'athena'
              ? !show_currency_selector
                ? ''
                : $store.state.pricetype
              : ''
          "
          :appendToBody="false"
          :regularFontSize="theme == 'athena' ? 24 : null"
          :fontSize="theme == 'athena' ? 24 : null"
        ></v-selectprice>
        <div
          v-if="theme == 'showtime' && now_variant.agio > 0"
          class="sale-tag saveprice"
        >
          <span class="secondary_title">{{ $t("home.save") }}</span>
          <v-selectprice
            :currency_style="currency_style"
            :disable_select="true"
            :country="show_currency_selector ? $store.state.pricetype : ''"
            saletag="saletag"
            :price="now_variant.agio"
            font-size="15"
          ></v-selectprice>
        </div>
        <div
          v-if="
            theme == 'athena' && computed_price && computed_price.percentage
          "
          class="sale-tag2 d-md-block d-none"
        >
          {{ computed_price.percentage }}% off
        </div>
        <div
          v-if="discount_label && theme == 'vogue'&& (show_label)"
          class="label-box"
          :class="`label--${discount_label_style}`"
          :style="{
            backgroundColor:label_background,
            color:label_color
          }"
        >
          <div class="label-item1">{{rate}}</div>
          <div class="label-item2">
              <div>%</div>
              <div class="off">OFF</div>
          </div>
          <div class="label-item3">SALE</div>
        </div>
      </h3>
    </div>
    <div class="product_add_cart">
      <!-- buyxgetyShowLocation == 'price_down' -->
      <!-- 满送优惠 -->
      <v-buyx-gety
        v-if="(buyxgetyShowLocation == 'price_down'|| !buyxgetyShowLocation ) && buyxgety_coupon.length"
        :buyxgety_coupon="buyxgety_coupon"
        :add_cart_data="{ ...add_cart_data }"
        :cart_type="cart_type"
        :show_currency_selector="show_currency_selector"
        :currency_style="currency_style"
        :model_style="theme == 'athena' ? 'hide_top_border' : ''"
        :theme="theme"
        :buyxgety-setting="buyxgetySetting"
      ></v-buyx-gety>
      <v-combinations
        :combinations="combinations"
        :style_combination="style_combination"
        :combination_active="combination_active"
        :theme="theme"
      ></v-combinations>
      <v-sharing-incentives
        :product_res="product_res"
        :data="incentives_data"
        v-if="incentives_data && incentives_data.length"
      />
      <div class="product_single">
        <template
          v-if="
            (product_res.variants && product_res.variants.length > 1) ||
            (product_res.variants_detail &&
              product_res.variants_detail.length > 1)
          "
        >
          <v-product-palette
            type="detail"
            v-if="palette_config && palette_attrs && palette_attrs.length"
            :palette_attrs="palette_attrs"
            :variant_attrs="variant_attrs"
            :palette_config="palette_config"
            :variants_show_config="variants_show_config"
            :theme="theme"
            :has_special_attrs="has_special_attrs"
            :add_cart_data="add_cart_data"
            :hide_number_select="hide_number_select"
            :product_res="product_res"
            :disabled="disabled"
            :stock="stock"
            :add_cart="add_cart"
            use_model_name="productcontent"
            :smartShowAttrsName="true"
          />
          <div v-else>
            <v-inputBox
              :variants_show_config="variants_show_config"
              :product_res="product_res"
              :theme="theme"
              :variant_attrs="variant_attrs"
            ></v-inputBox>
          </div>
        </template>

        <!-- buyxgetyShowLocation == 'attr_down' -->
        <!-- 满送优惠 -->
        <v-buyx-gety
          v-if="(buyxgetyShowLocation == 'attr_down') && buyxgety_coupon.length"
          :buyxgety_coupon="buyxgety_coupon"
          :add_cart_data="{ ...add_cart_data }"
          :cart_type="cart_type"
          :show_currency_selector="show_currency_selector"
          :currency_style="currency_style"
          :model_style="theme == 'athena' ? 'hide_top_border' : ''"
          :theme="theme"
          :buyxgety-setting="buyxgetySetting"
        ></v-buyx-gety>
        <div class="custom-form-properties"></div>
        <div :class="{ 'd-md-block d-none': has_special_attrs && palette_config }">
          <v-numberLabel
            v-if="hide_number_select !== 1"
            :product_res="product_res"
            :add_cart_data="add_cart_data"
            :disabled="disabled"
            :stock="stock"
            :theme="theme"
            :add_cart="add_cart"
          ></v-numberLabel>
        </div>
      <!-- buyxgetyShowLocation == 'num_down' -->
      <!-- 满送优惠 -->
      <v-buyx-gety
        v-if="(buyxgetyShowLocation == 'num_down' ) && buyxgety_coupon.length"
        :buyxgety_coupon="buyxgety_coupon"
        :add_cart_data="{ ...add_cart_data }"
        :cart_type="cart_type"
        :show_currency_selector="show_currency_selector"
        :currency_style="currency_style"
        :model_style="theme == 'athena' ? 'hide_top_border' : ''"
        :theme="theme"
        :buyxgety-setting="buyxgetySetting"
      ></v-buyx-gety>
        <div class="custom-form-properties"></div>
        <!-- 尺码组件 -->
        <v-size-chart
          v-if="enable_size_chart"
          :style="{ marginTop: '12px' }"
          :product_id="product.ID"
        />
      </div>
      <v-show-visits v-if="visitors" :data="visitors"></v-show-visits>
      <v-codedisplay
        :theme="theme"
        v-if="code_display && code_display_show.length"
        :code_display_show="code_display_show"
      ></v-codedisplay>
      <v-sellFeatures
      ></v-sellFeatures>
      <v-new-grouped-product
        v-if="theme == 'athena' && group_product && group_product.length && groupProduct.position === 'button_above'"
        :group_product="group_product"
        :group_products_title="group_products_title"
        @checked_variants_info="checked_variants_info"
        :now_variant_computed_price="computed_price"
        :cart_type="cart_type"
        :theme="theme"
        :now_variant_add_cart_data="add_cart_data"
        :group_product_price_rules="group_product_price_rules"
      ></v-new-grouped-product>
      <v-grouped-product
        v-if="
          theme !== 'athena' &&
          add_group_products &&
          group_product &&
          group_product.length > 0 &&
          groupProduct.position === 'button_above'
        "
        :price="now_variant.price"
        :regular_price="now_variant.regular_price"
        :stock="now_variant.buy_able && stock"
        :loading="$store.state.disabled"
        :group_product="group_product"
        :group_product_all="groupProduct"
        :group_products_title="groupProduct.title"
        :group_products_position="groupProduct.position"
        :product="product"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :cart_type="cart_type"
        :theme="theme"
        :show_currency_selector="show_currency_selector"
        :currency_style="currency_style"
        :group_product_style="groupProduct.style"
        @checked_variants_info="checked_variants_info"
        @get_group_price="get_group_price"
        :now_variant_computed_price="now_variant"
      ></v-grouped-product>
      <div class="product_single_add" :class="{'single-add-block':group_product && group_product.length && groupProduct.position === 'button_above'}">
        <button
          v-if="now_variant.buy_able && stock"
          v-show="hide_add_btn !== true"
          type="button"
          class="product_single_add_button addToCartAllThemeBtnClass"
          :class="{
            text_font_size:
              theme == 'vogue' &&
              langs.includes(this.$i18n.locale) &&
              show_product_price,
            product_single_add_button_disabled: disabled,
            'add-to-cart': theme == 'showtime',
            'transition-main': theme == 'vogue' && button_type !== 'buynow',
            'transition-minor': theme == 'vogue' && button_type == 'buynow',
            minor_button: theme != 'vogue' && button_type == 'buynow',
            main_button: theme != 'vogue' && button_type !== 'buynow',
            single_add_btn: theme == 'athena' && !button_type,
          }"
          @click="!disabled && add_cart('athenaGroupProduct')"
          :disabled="disabled"
        >
          <!--  (theme == 'athena' && group_product && group_product.length&&'athenaGroupProduct') 判断是否是加购雅典娜的组合商品  -->
          <!-- 历史问题，不合理的实现 -->
          <!-- icongouwuche showTime 图标 -->
          <!-- icon-gouwuche vogue图标 -->
          <span class="iconfont icongouwuche icon-gouwuche"></span>
          <span class="secondary_title add-buttom__text">
            {{ $t("detail.add_to_cart") }}
            <template v-if="show_product_price">
              <v-dot></v-dot>
              <v-selectprice
                :currency_style="currency_style"
                :price="Number(now_variant.price) + groupPrice"
                :default_price_class="false"
                :disable_select="true"
                fontSize="14"
                :show_country="false"
                :country="
                  theme == 'showtime' || theme == 'vogue'
                    ? !show_currency_selector
                      ? ''
                      : $store.state.pricetype
                    : ''
                "
                :appendToBody="false"
              ></v-selectprice>
            </template>
          </span>
        </button>

        <!-- 售罄按钮 -->
        <button
          v-else
          v-show="hide_add_btn !== true"
          type="button"
          class="
            product_single_add_button product_single_add_button_disabled addToCartAllThemeBtnClass
            soldout
          "
          :class="{
            'add-to-cart': theme == 'showtime' || theme == 'vogue',
          }"
          :disabled="true"
        >
          <span class="secondary_title">{{ $t("detail.sold_out") }}</span>
        </button>

        <!-- 直接购物按钮 -->
        <div
          class="buynow secondary_title"
          v-if="button_type == 'buynow'"
          :class="[
            theme == 'vogue' ? 'transition-main' : 'main_button',
            { product_single_add_button_disabled: disabled },
          ]"
          v-show="now_variant.buy_able && stock"
          @click="!disabled && add_cart('buynow')"
        >
          {{ $t("detail.but_it_now") }}
        </div>

        <!-- 贝宝直接支付 -->
        <v-paypal-btn
          v-if="button_type == 'paypal'"
          v-show="now_variant.buy_able && stock"
          :addproduct="JSON.stringify(add_cart_data)"
          :add_cart_list="add_cart_list?JSON.stringify(add_cart_list):'[]'"
          :group_checked_variants_info="group_checked_variants_info?JSON.stringify(group_checked_variants_info):'[]'"
        >
        </v-paypal-btn>
        <div  v-if="button_type == 'paypal'" class="text-center product_single_add--paypal_but_it_now">
          <span  @click="!disabled && add_cart('buynow')">
            {{ $t('add.more_payment_options') }}
          </span>
        </div>
        <!-- 自定义按钮 -->
        <v-custom-button
          style="margin-top: 0px"
          v-if="custom_button && custom_button.is_detail_page == '1'"
          :custom_button="custom_button"
        ></v-custom-button>
        <v-bulk-coupon
          v-if="has_bulk_coupon"
          :cart_type="cart_type"
          :bulk_coupon="bulk_coupon"
          :product_id="add_cart_data.product_id"
          :variant_id="add_cart_data.variant_id"
          :stock="stock"
          :product="product"
          :theme="theme"
        ></v-bulk-coupon>
      </div>
      <v-new-grouped-product
        v-if="theme == 'athena' && group_product && group_product.length && groupProduct.position === 'button below'"
        :group_product="group_product"
        :group_products_title="group_products_title"
        @checked_variants_info="checked_variants_info"
        :now_variant_computed_price="computed_price"
        :now_variant_add_cart_data="add_cart_data"
        :cart_type="cart_type"
        :theme="theme"
      ></v-new-grouped-product>
    </div>
    <v-product-share
      v-if="!noshare"
      :show_style="show_style"
      :product_res="product_res"
      :share_event="share_event"
      :show_name="theme == 'athena'"
      :theme="theme"
      :enable_facebook="enable_facebook"
      :enable_twitter="enable_twitter"
      :enabel_pinterest="enabel_pinterest"
    ></v-product-share>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import mixAdd from "@/js/mixins/mixAdd";
import mixProperties from "@/js/mixins/mixProperties";
import vBulkCoupon from "@/js/components/common/bulkcoupon";
import vBuyxGety from "@/js/components/view/buyxgety";
import vSharingIncentives from '@/js/components/applications/SharingIncentives/index.vue';
import vShowVisits from "@/js/components/view/showvisits/index";
import vProDelStart from "@/js/components/view/comments/proDelStart.vue";
import vCombinations from "@/js/components/view/combinations/combinations.vue";
import vDot from "@/js/components/common/dot.vue";
import vProductShare from "./productShare";
import vInputBox from "./InputBox.vue";
import vIselect from "@/js/components/view/productpalette/iselect";
import vSizeChart from "@/js/components/applications/SizeChart";
import vNumberLabel from "./numberLabel.vue";
import vNewGroupedProduct from "@/js/components/view/groupedproduct/newIndex.vue";
import vGroupedProduct from "@/js/components/view/groupedproduct/index";
import vCountdown from '@/js/components/common/countdown.vue'
import vProductPalette from '@/js/components/view/productpalette/index.vue'
import vCodedisplay from '@/js/components/view/codedisplay/index.vue'

export default {
  props: [
    "product",
    "pc_add_button",
    "count_down",
    "count_down_show",
    "cart_type",
    "show_currency_selector",
    "paypal_product_position",
    "variants_show_config",
    "bulk_coupon",
    "has_bulk_coupon",
    "theme",
    "add_cart_data",
    "variant_attrs", //创建好的加购属性
    "now_variant",
    "enable_facebook",
    "enable_twitter",
    "enabel_pinterest",
    "singlecommoditydescription",
    "singlecommodity",
    "stock",
    "code_display",
    "code_display_show",
    "currency_style",
    "paypal_enabled",
    "buyxgety_coupon",
    "incentives_data",
    "custom_button",
    "palette_attrs",
    "palette_config",
    "visitors",
    "hide_add_btn",
    "show_comment_score",
    "comment",
    "show_product_price",
    "hide_number_select",
    "show_style",
    "computed_price",
    "style_combination",
    "add_cart_list",
    "combinations",
    "enable_size_chart",
    "style_combination",
    "has_special_attrs",
    "combination_active",
    "group_product",
    "group_products_title",
    "add_group_products",
    "getSymbolFromCurrency",
    "group_product_price_rules",
    "buyxgetySetting",
    "noshare",
    "untreated_product", // 未经过mixproduct处理的商品信息
  ],
  mixins: [mixAdd,mixProperties],
  data() {
    return {
      product_res: {},
      disabled: false,
      add_button_box: {},
      arrive_top: 0,
      variant_id: null,
      langs: ["German", "Portuguese", "Dutch","French","Italian","Russian","Spanish"],
      group_checked_variants_info:[],
      show_label:true,
      regularPrice:0,
      price:0,
      rate:0,// 折扣比例
      buyxgetyShowLocation:null, //满送优惠显示的位置
      groupPrice: 0, //获取组合商品的价格
      addType:'product.add',
    };
  },

  methods: {
    show_percentage(regularPrice,price) {
      let newRate = 0
      newRate = Math.ceil((1 - price / regularPrice).toFixed(2) * 100)
      if((newRate < 1 ||isNaN(newRate))
      ){
        this.show_label = false
      } else {
        this.show_label = true
      }
      return newRate
    },
    preferential_percentage() {
      const regularPrice = (this.computed_price &&
      this.computed_price.regular_price > this.computed_price.price &&
      this.computed_price.regular_price)||
                  ( this.now_variant.regular_price - 0 > this.now_variant.price - 0
      ? this.now_variant.regular_price : 0)
      const price = (this.computed_price && this.computed_price.price) || this.now_variant.price
      this.rate =  this.show_percentage(regularPrice,price)
    },
    mixAddCartBefore() {
      return this.mixProperties();
    },
    checked_variants_info(payload) {
      this.group_checked_variants_info = payload;
    },
    get_group_price(payload) {
      this.groupPrice = payload;
    },
    async share_event(e) {
      try {
        let res = await this.$axios.post(API.statis_event, {
          name: "shares." + e,
          parameters: { url: window.location.href },
        });
      } catch (error) {
        console.log(error);
      }
    },
    fixe_add_button() {
      let window_scroll = this.$(window).scrollTop(); // 文档滚动高度
      let header = this.$(".header"); // 页头
      // top :页头的高度
      const header_height =   this.headerConfig.visibility ? header.height(): 0;
      const product_top = this.$(".product_single_bottom.clearfix").offset().top; // 商品详情距顶部的距离
      const product_all_top = this.$(".product_single_bottom.clearfix").height(); // 商品详情距高度
      const client_height =document.documentElement.clientHeight // 可视区窗口高度
     
      const product_to_footer =  client_height + window_scroll -  product_top  -product_all_top //  当前商品与底部的距离 


      if (window_scroll > product_top && this.add_button_box.outerHeight() < client_height - header_height) {
        if(product_to_footer < 0){
          this.add_button_box.css({
            position: 'relative',
            top: window_scroll - this.$('.product_single_top').outerHeight() - 45
          });
        }
      }else{
         this.add_button_box.css({
          top: 0,
        });
      }
    },
    windowResize() {
      this.add_button_box = this.$(this.$el);
      if (this.screenWidth > 980 && this.theme == "venue") {
        window.addEventListener('scroll',  this.fixe_add_button, true)
      } else {
         this.add_button_box.css({ position: "static", top:0 ,transform:'unset'});
        window.removeEventListener("scroll", this.fixe_add_button,true);
      }
    },
  },
  beforeMount() {
    let inputnum = JSON.parse(window.sessionStorage.getItem("inputnum"));
    if (
      window.performance.navigation.type == 2 &&
      inputnum &&
      inputnum[this.product.ID]
    ) {
      this.add_cart_data.quantity = inputnum[this.product.ID];
    }
    this.product_res = this.product;
    this.add_cart_data.product_id = this.product_res.ID;
  },
  mounted() {
    this.windowResize();
    window.onresize = () => {
      this.windowResize();
    };
    this.preferential_percentage()
    if(this.buyxgetySetting){
      this.buyxgetyShowLocation = this.buyxgetySetting?.show_local
    }
  },
  watch: {
    now_variant(v){
      this.regularPrice = (this.computed_price &&
      this.computed_price.regular_price > this.computed_price.price &&
      this.computed_price.regular_price)||
                  ( v.regular_price - 0 > v.price - 0
      ? v.regular_price : 0)
      this.price = (this.computed_price && this.computed_price.price) || v.price
      this.rate = this.show_percentage(this.regularPrice, this.price)
    },
    buyxgetySetting: {
      handler(newV) {
         this.buyxgetyShowLocation = newV?.show_local
      },
      deep: true,
      immediate: false,
    }
  },
  components: {
    vBulkCoupon,
    vBuyxGety,
    vSharingIncentives,
    vShowVisits,
    vProDelStart,
    vDot,
    vProductShare,
    vInputBox,
    vCombinations,
    vIselect,
    vSizeChart,
    vCombinations,
    vNumberLabel,
    vNewGroupedProduct,
    vGroupedProduct,
    vCountdown,
    vProductPalette,
    vCodedisplay,
  },
  computed: {
    // 组合商品位于按钮上方
    mainProduct() {
      return this.groupProduct?.hasOwnProperty('position') && this.groupProduct.position != 'button_above' && this.untreated_product
    },    
    ...mapState({
      // 组合商品配置
      groupProduct: ({ plugConfig }) => plugConfig.groupProduct || {},
      discount_label: ({ options }) => options?.theme?.pages?.product?.config?.discount_label,
      discount_label_style: ({ options }) => options?.theme?.pages?.product?.config?.discount_label_style,
      label_background: ({ options }) => options?.theme?.pages?.product?.config?.background_color,
      label_color: ({ options }) => options?.theme?.pages?.product?.config?.text_color,
      screenWidth: ({ screenWidth }) => screenWidth,
      headerConfig: ({ options }) => options?.theme?.modules?.header || {},
    }),
  },
};
</script>
<style scoped lang='scss'>
.sale-tag {
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  padding: 0 8px;
  border-radius: 3px;
  vertical-align: text-bottom;
  color: #898e88;
  border: 2px solid #898e88;
}
.sale-tag2 {
  display: inline-block;
  font-size: 14px;
  line-height: 26px;
  width: 80px;
  background: #222222;
  border-radius: 13px;
  text-align: center;
  color: #fff;
  vertical-align: text-bottom;
}
.product_single_right_box {
  width: 100%;
  border: 1px solid #e4e4e4;
  padding-bottom: 12px;
  background-color: #fff;
}
.product_single_box {
  .product_single_price {
    position: relative;
    background: none;
    padding: 6px 24px;
    &::v-deep .show_comment_score {
      margin-top: 16px;
    }
    .product_single_price_text {
      margin-bottom: 0;
      font-weight: bold;
      .product_price_number_compare {
        font-size: 1.06rem;
        color: #b89797;
        margin-left: 6px;
        text-decoration: line-through;
      }
    }
    .product_subtitle {
      margin-top: 7px;
      font-size: 22px;
      font-family: Roboto;
      font-weight: 400;
      color: #888888;
      width: 100%;
    }
  }

  .product_add_cart {
    padding: 12px 24px 0;
  }
  .product_single_add {
    margin-top: 12px;
    position: relative;
    &--paypal_but_it_now {
      width: 100%;
      margin-bottom: 16px;
      text-decoration: underline;
      font-style: italic;
      font-size: 14px;
      font-family: var(--text-font-family);
      span{
        cursor: pointer;
      }
    }
    button {
      margin-bottom: 12px;
    }
    .product_single_add_button {
      box-sizing: border-box;
      .secondary_title {
        font-size: 14px;
        &::v-deep .selectpricewrap .product_price_price {
          cursor: pointer;
        }
      }
    }
    .paypal-button-render {
      position: relative;
      z-index: 1;
      margin-bottom: 18px;
    }
    .buynow {
      width: 100%;
      background-color: #111112;
      color: #e6e6e7;
      text-align: center;
      font-size: 13px;
      font-family: "Oswald", sans-serif;
      line-height: 48px;
      height: 48px;
      letter-spacing: 1px;
      cursor: pointer;
      margin-bottom: 18px;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .product_single_share {
    .social-sharing {
      text-align: center;
      margin: 0;
      padding-left: 0px;
      height: 31px;
      span {
        display: inline-block;
        margin: 3px 6px;
        font-size: 16px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        color: #b89797;
        cursor: pointer;
      }
    }
  }
  .view-detail {
    font-size: 18px;
  }
}
.vogue_add,
.athena_add {
  .product_add_cart {
    padding-top: 10px !important;
    .product_single {
      &::v-deep .input_attrs_box {
        .variant_select {
          margin-bottom: 10px !important;
        }
      }
      &::v-deep .product_qty_box {
        label {
          color: #1e0909 !important;
        }
      }
    }
  }
}
.showtime_add,
.vogue_add,
.athena_add {
  width: 100%;
  border-color: transparent !important;
  background-color: transparent !important;
  padding-bottom: 0 !important;
  .product_single_price {
    padding: 0px !important;
    h1 {
      line-height: 1.5;
      color: #2f2f2f;
      font-size: 18px;
      margin: 5px 0 5px;
    }
  }
  .product_add_cart {
    padding: 30px 0 0;

    .product_single {
      &::v-deep .variant_attrs_box {
        & > .variant_select:last-child {
          margin-bottom: 20px;
        }
        .variant_select {
          & > label {
            margin-bottom: 6px;
            font-size: 14px;
          }
          select {
            max-width: 100%;
            background-color: transparent !important;
            border-color: #dedede !important;
            color: #858585 !important;
          }
        }
        .dropdown {
          width: 40%;
          &::after {
            top: unset;
            bottom: 13px !important;
          }
        }
      }
      &::v-deep .product_qty_box {
        label {
          line-height: unset;
          color: #858585;
          font-size: 14px;
        }
        .product_qty {
          float: unset;
        }
      }
    }
    .product_single_add {
      display: inline-block;
      width: auto;

      button {
        text-transform: uppercase;
        margin-bottom: 12px;
        width: 100%;
      }
      .buynow {
        width: 100%;
        font-size: 14px;
        font-family: Lato, sans-serif;
        text-transform: uppercase;
      }
    }
  }
  .product_single_share {
    .social-sharing {
      text-align: left;
    }
  }
}
.showtime_add {
  .product_add_cart {
    .product_single_add {
      min-width: 400px !important;
    }
    .single-add-block {
      display: block !important;
    }
  }
}
.vogue_add,
.athena_add {
  .countdown {
    margin-bottom: 12px;
  }
  .product_single_price {
    h1 {
      font-size: 24px;
      font-weight: bold;
      margin-top: -5px;
    }
    .product_single_price_text::v-deep .price_text {
      font-size: 25px !important;
    }
  }
  .product_add_cart {
    .product_single_add {
      width: 100%;
    }
  }
}
.vogue_add {
  .product_single_price {
    .product_single_price_text {
      display: flex;
      align-items: center;
      .label--percent {
        .label-item3 {
          display: none;
        }
      }
      .label--icon {
        .label-item1,.label-item2 {
          display: none;
        }
      }
      .label-box {
        font-weight: bold;
        line-height: 26px;
        width: auto;
        display: flex;
        height: 36px;
        align-items: center;
        padding: 0 12px;
        margin-left: 6px;
        .label-item1 {
          font-size: 24px;
        }
        .label-item2 {
          font-size: 14px;
          flex-direction: column;
          text-align: left;
          padding-left: 2px;
          line-height: 12px;
          .off {
            font-size: 8px;
          }
        }
        .label-item3 {
          font-size: 14px;
        }
      }
    }
  }
}
.athena_add {
  .product_single_price {
    padding: 0;
    padding-bottom: 30px !important;
    border-bottom: 1px solid #e2e2e2;
    h1 {
      font-size: 24px;
      color: #3a3a3a;
    }
    &::v-deep .show_comment_score {
      margin-top: 12px;
    }
  }
  .product_single_price {
    .product_single_price_text {
      display: flex;
      align-items: center;
    }
  }
  .product_add_cart {
    .product_single_add {
      font-size: 0;
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .single_add_btn {
        width: 100% !important;
      }
    }
    .product_single_add_button,
    .buynow,
    .paypal-button-render {
      box-sizing: border-box;
      padding: 0 15px;
      width: calc(50% - 10px) !important;
      display: inline-block !important;
      background-color: #ffc439;
      height: 54px !important;
    }
    .buynow,
    .paypal-button-render {
      line-height: 54px !important;
      vertical-align: top;
    }
    .paypal-button-render {
      max-height: 54px;
      &::v-deep > div {
        height: 54px !important;
      }
    }

    .product_single {
      &::v-deep {
        .variant_attrs_box {
          & > .variant_select:last-child {
            margin-bottom: 12px;
          }
          .dropdown {
            width: 100%;
            select {
              border-color: #000 !important;
              color: #000 !important;
              font-weight: bold !important;
              padding-left: 20px !important;
              height: 52px;
              font-size: 16px;
            }
          }
          .dropdown::after {
            color: #000 !important;
            font-weight: bolder !important;
          }
          .variant_select {
            & > label {
              font-size: 18px !important;
              line-height: 48px !important;
              &::after {
                //content: ":";
                margin-left: 5px;
              }
            }
          }
        }
        .product_qty_box {
          label {
            font-size: 18px !important;
            line-height: 48px !important;
          }
          .product_qty {
            button,
            input {
              height: 52px;
              height: 52px;
              font-size: 20px;
              background: #fff;
              border-color: #000;
            }
            button {
              width: 52px;
            }
            input {
              width: 100px;
            }
          }
        }
      }
    }
  }
}
@media screen and(max-width:786px) {
  .product_single_box {
    position: unset !important;
    .product_single_price {
      &::v-deep .show_comment_score {
        margin-top: 9px;
      }
    }
  }
  .showtime_add,
  .vogue_add,
  .athena_add {
    .countdown {
      margin-left: -24px;
      margin-right: -24px;
    }
    .product_add_cart {
      .product_single {
        &::v-deep .variant_attrs_box {
          .variant_select {
            width: 100% !important;
            max-width: 100% !important;
          }
        }
      }
      .product_single_add {
        width: 100%;
        min-width: unset !important;
      }
    }
  }
  .vogue_add,
  .athena_add {
    position: unset !important;
    .product_single_price {
      h1 {
        font-size: 18px;
        margin-top: 18px;
        font-family: Muli-ExtraBold !important;
      }
      .product_single_price_text::v-deep .price_text {
        font-size: 22px !important;
      }
    }
  }
  .athena_add {
    .product_single_price {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      text-align: center;
      justify-content: space-around;
      border: none;
      padding-bottom: 0 !important;

      & > h1 {
        width: 100%;
        margin-top: 10px;
        font-size: 15px;
        line-height: 20px;
      }
      .product_subtitle {
        font-size: 14px;
        margin-top: 0px;
      }
      &::v-deep {
        .athena_comment_score {
          margin-top: 0;
          order: 2;
        }
        .product_single_price_text {
          .product_price_price,
          .product_price_cross {
            .money {
              font-size: 15px !important;
            }
          }
        }
      }
    }
    .product_add_cart {
      padding-top: 0 !important;
      .product_single_add_button,
      .buynow {
        padding: 0 !important;
      }
      .product_single_add_button,
      .buynow,
      .paypal-button-render {
        height: 40px !important;
        margin-bottom: 0;
      }
      .buynow,
      .paypal-button-render {
        line-height: 40px !important;
      }
      .paypal-button-render {
        max-height: 40px;
        overflow: hidden;
        // @media only screen and (min-width: 150px) {
        //   .paypal-button:not(.paypal-button-card) {
        //     height: 40px;
        //     min-height: 40px;
        //     max-height: 40px;
        //   }
        // }
        &::v-deep > div {
          transform: translate(-6px, -6px);
        }
      }
      .product_single {
        &::v-deep {
          .variant_attrs_box {
            .dropdown {
              margin: 0 !important;
              select {
                margin: 0;
                border-color: #cccccc !important;
                padding: 0;
                padding-left: 20px;
                height: 34px;
              }
            }
            .dropdown::after {
              bottom: 9px !important;
            }
            .variant_select {
              & > label {
                font-size: 13px !important;
                line-height: 42px !important;
                margin: 0;
              }
            }
          }
          .product_qty_box {
            // margin-bottom: 30px;

            label {
              margin: 0;
              font-size: 13px !important;
              line-height: 42px !important;
            }
            .product_qty {
              //width: 100%;
              width: unset;
              button:nth-of-type(1) {
                border-right: 0;
                box-sizing: border-box;
              }
              button:nth-of-type(2) {
                border-left: 0;
                box-sizing: border-box;
              }
              input {
                border-color: #cccccc !important;
                box-sizing: border-box;
                border-right: 0;
                border-left: 0;
                height: 34px;
                font-size: 13px;
                font-weight: 600;
              }
              button {
                height: 34px;
                width: 20%;
                border-color: #cccccc !important;
              }
              input {
                width: 20%;
              }
            }
          }
        }
      }
    }
  }
  .vogue_add {
    .product_single_add {
      .product_single_add_button.text_font_size {
        padding: 9px 10px;
      }
      .text_font_size {
        .secondary_title {
          font-size: 12px !important;
          .dot {
            margin: 0 10px;
            margin-bottom: 3px;
          }
        }
        &::v-deep .product_price_price {
          .money {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}
</style>
